import jsonAPI from './json-api'

class News {
  constructor () {
    this._conf = {
      baseURL: '/api/v1',
      method: 'post'
    }
  }

  // 新闻列表
  list (param) {
    return jsonAPI.requestWithAuth('/getNewsList', param, this._conf)
  }

  // 首页右侧时政新闻列表
  politicalNewsList () {
    return jsonAPI.requestWithAuth('/getCourseList', {}, this._conf)
  }

  // 新闻详情
  newDetail (param) {
    return jsonAPI.requestWithAuth('/getNewsById', param, this._conf)
  }

  // 热门新闻
  hotNewsList (param) {
    return jsonAPI.requestWithAuth('/getNewsRight', param, this._conf)
  }
}

export default new News()
